import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Stage, Layer, Image, Circle, Rect, Line, Ring, Group, Text } from 'react-konva';
import useImage from 'use-image';

// const Kuroki2 = ({ formik, KurokiImage }) => {
//   const { t } = useTranslation();
//   const [image] = useImage(KurokiImage);
//   const [innerRadiusRatio] = useState(0.8);
//   const [scaleFactor] = useState(0.9);

//   const markers = formik.values.markers;

//   return (
//     <div style={{ display: 'flex', gap: '20px' }}>
//       {/* المسرح مع العلامات */}
//       <div className='d-inline-block'>
//         <Stage width={600 * scaleFactor} height={400 * scaleFactor}>
//           <Layer>
//             <Image image={image} width={600 * scaleFactor} height={400 * scaleFactor} />

//             {markers?.map((marker, index) => {
//               if (!marker || isNaN(marker.x) || isNaN(marker.y) || isNaN(marker.size)) {
//                 return null;
//               }

//               const markerColor = marker.color;
//               const currentSize = Number(marker.size) * scaleFactor;
//               const scaledX = Number(marker.x) * scaleFactor;
//               const scaledY = Number(marker.y) * scaleFactor;

//               return (
//                 <Group key={index}>
//                   {/* Render the marker shape */}
//                   {marker.shape === 'circle' && (
//                     <Circle
//                       x={scaledX}
//                       y={scaledY}
//                       radius={currentSize}
//                       fill={markerColor}
//                       stroke={'transparent'}
//                       strokeWidth={1}
//                     />
//                   )}
//                   {marker.shape === 'square' && (
//                     <Rect
//                       x={scaledX - currentSize}
//                       y={scaledY - currentSize}
//                       width={currentSize * 2}
//                       height={currentSize * 2}
//                       fill={markerColor}
//                       stroke={'transparent'}
//                       strokeWidth={1}
//                     />
//                   )}
//                   {marker.shape === 'line' && (
//                     <Line
//                       points={[scaledX - currentSize * 2, scaledY, scaledX + currentSize * 2, scaledY]}
//                       stroke={markerColor}
//                       strokeWidth={currentSize / 2}
//                     />
//                   )}
//                   {marker.shape === 'ring' && (
//                     <Ring
//                       x={scaledX}
//                       y={scaledY}
//                       innerRadius={currentSize * Number(innerRadiusRatio)}
//                       outerRadius={currentSize}
//                       fill={markerColor}
//                       stroke={'transparent'}
//                       strokeWidth={1}
//                     />
//                   )}

//                   {/* رقم التعليق بجانب العلامة */}
//                   <Text
//                     x={scaledX + currentSize + 5}
//                     y={scaledY - 8}
//                     text={(index + 1).toString()}
//                     fontSize={14 * scaleFactor}
//                     fill={markerColor}
//                     fontStyle='bold'
//                   />
//                 </Group>
//               );
//             })}
//           </Layer>
//         </Stage>
//       </div>

//       {/* قائمة التعليقات الجانبية */}
//       <div
//         style={{
//           width: '200px',
//           padding: '10px',
//           border: '1px solid #ddd',
//           borderRadius: '5px',
//           backgroundColor: '#f9f9f9'
//         }}
//       >
//         <h4 style={{ marginBottom: '15px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>{t('Comments')}</h4>
//         <ol style={{ paddingLeft: '20px', margin: 0 }}>
//           {markers?.map((marker, index) => (
//             <li key={index} style={{ marginBottom: '10px', color: marker.color }}>
//               {marker.comment || t('No comment')}
//             </li>
//           ))}
//         </ol>
//       </div>
//     </div>
//   );
// };
const Kuroki2 = ({ formik, KurokiImage }) => {
  const { t } = useTranslation();
  const [image] = useImage(KurokiImage);
  const [innerRadiusRatio] = useState(0.8);
  const [scaleFactor] = useState(0.8); // Scaling factor (0.9 means 90% scaling)

  const markers = formik.values.markers;

  return (
    <div className='d-flex justify-content-between align-items-start'>
      {/* Numbered Comments List */}
      <div className='me-3'>
        <h6>
          <i className='bi bi-chat-dots me-2 fa-lg'></i>
          {t('Comments')}
        </h6>
        <ul className='list-group text-start '>
          {markers?.map((marker, index) => (
            <li key={`comment-${index}`} className='list-group-item fs-12px fw-bold p-1'>
              {index + 1}. {marker.comment || 'No comment'}
            </li>
          ))}
        </ul>
      </div>

      {/* Canvas Stage */}
      <div className='d-inline-block'>
        <Stage
          width={600 * scaleFactor} // Scaled stage width
          height={400 * scaleFactor} // Scaled stage height
        >
          <Layer>
            <Image image={image} width={600 * scaleFactor} height={400 * scaleFactor} />

            {markers?.map((marker, index) => {
              if (!marker || isNaN(marker.x) || isNaN(marker.y) || isNaN(marker.size)) {
                return null;
              }

              const markerColor = marker.color;
              const currentSize = Number(marker.size) * scaleFactor; // Scaled marker size
              const scaledX = Number(marker.x) * scaleFactor; // Scaled x coordinate
              const scaledY = Number(marker.y) * scaleFactor; // Scaled y coordinate

              // Render the marker based on its shape
              const renderMarker = () => {
                if (marker.shape === 'circle') {
                  return (
                    <Circle
                      key={`circle-${index}`}
                      x={scaledX}
                      y={scaledY}
                      radius={currentSize}
                      fill={markerColor}
                      stroke={'transparent'}
                      strokeWidth={1}
                    />
                  );
                } else if (marker.shape === 'square') {
                  return (
                    <Rect
                      key={`rect-${index}`}
                      x={scaledX - currentSize}
                      y={scaledY - currentSize}
                      width={currentSize * 2}
                      height={currentSize * 2}
                      fill={markerColor}
                      stroke={'transparent'}
                      strokeWidth={1}
                    />
                  );
                } else if (marker.shape === 'line') {
                  return (
                    <Line
                      key={`line-${index}`}
                      points={[scaledX - currentSize * 2, scaledY, scaledX + currentSize * 2, scaledY]}
                      stroke={markerColor}
                      strokeWidth={currentSize / 2}
                    />
                  );
                } else if (marker.shape === 'ring') {
                  return (
                    <Ring
                      key={`ring-${index}`}
                      x={scaledX}
                      y={scaledY}
                      innerRadius={currentSize * Number(innerRadiusRatio)}
                      outerRadius={currentSize}
                      fill={markerColor}
                      stroke={'transparent'}
                      strokeWidth={1}
                    />
                  );
                }
                return null;
              };

              return (
                <>
                  {renderMarker()}
                  {/* Render the marker's index number next to it */}
                  <Text
                    key={`number-${index}`}
                    x={scaledX + currentSize + 5} // Position number to the right of the marker
                    y={scaledY - 5} // Slightly above the marker's center
                    text={`${index + 1}`} // Display 1-based index
                    fontSize={12 * scaleFactor} // Scale font size
                    fill='black' // Text color
                    fontFamily='Arial'
                    align='left'
                    listening={false} // Make text non-interactive
                  />
                </>
              );
            })}
          </Layer>
        </Stage>
      </div>
    </div>
  );
};
export default Kuroki2;

// const Kuroki2 = ({ formik, KurokiImage }) => {
//   const { t } = useTranslation();
//   const [image] = useImage(KurokiImage);
//   const [innerRadiusRatio] = useState(0.8);
//   const [scaleFactor] = useState(0.9); // عامل التحجيم (0.7 يعني تصغير بنسبة 70%)

//   const markers = formik.values.markers;

//   return (
//     <>
//       <div className='d-inline-block  '>
//         <Stage
//           width={600 * scaleFactor} // تصغير عرض المسرح
//           height={400 * scaleFactor} // تصغير ارتفاع المسرح
//         >
//           <Layer>
//             <Image image={image} width={600 * scaleFactor} height={400 * scaleFactor} />

//             {markers?.map((marker, index) => {
//               if (!marker || isNaN(marker.x) || isNaN(marker.y) || isNaN(marker.size)) {
//                 return null;
//               }

//               const markerColor = marker.color;
//               const currentSize = Number(marker.size) * scaleFactor; // تصغير حجم العلامة
//               const scaledX = Number(marker.x) * scaleFactor; // تصغير إحداثية x
//               const scaledY = Number(marker.y) * scaleFactor; // تصغير إحداثية y

//               if (marker.shape === 'circle') {
//                 return (
//                   <Circle
//                     key={index}
//                     x={scaledX}
//                     y={scaledY}
//                     radius={currentSize}
//                     fill={markerColor}
//                     stroke={'transparent'}
//                     strokeWidth={1}
//                   />
//                 );
//               } else if (marker.shape === 'square') {
//                 return (
//                   <Rect
//                     key={index}
//                     x={scaledX - currentSize}
//                     y={scaledY - currentSize}
//                     width={currentSize * 2}
//                     height={currentSize * 2}
//                     fill={markerColor}
//                     stroke={'transparent'}
//                     strokeWidth={1}
//                   />
//                 );
//               } else if (marker.shape === 'line') {
//                 return (
//                   <Line
//                     key={index}
//                     points={[scaledX - currentSize * 2, scaledY, scaledX + currentSize * 2, scaledY]}
//                     stroke={markerColor}
//                     strokeWidth={currentSize / 2}
//                   />
//                 );
//               } else if (marker.shape === 'ring') {
//                 return (
//                   <Ring
//                     key={index}
//                     x={scaledX}
//                     y={scaledY}
//                     innerRadius={currentSize * Number(innerRadiusRatio)}
//                     outerRadius={currentSize}
//                     fill={markerColor}
//                     stroke={'transparent'}
//                     strokeWidth={1}
//                   />
//                 );
//               }

//               return null;
//             })}
//           </Layer>
//         </Stage>
//       </div>
//     </>
//   );
// };
